export const MULTIPLICADORES = {
    grupos: 8,
    dieciseisavos: 9,
    octavos: 10,
    cuartos: 11,
    semifinal: 15,
    final: 20,
};
export const PUNTOS_CAMPEON = {
    grupos: 2000,
    dieciseisavos: 1500,
    octavos: 1000,
    cuartos: 700,
    semifinal: 400,
    final: 200,
};
export function puntosCampeonPorFase(fase) {
    return PUNTOS_CAMPEON[fase];
}
export const MULTIPLICADOR_TIPO = {
    normal: 0,
    tercer_puesto: 15,
    final: 20,
};
